/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_More_ToolsInputs */

const en_directory_detail_more_tools = /** @type {(inputs: Directory_Detail_More_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More tools to explore`)
};

const zh_directory_detail_more_tools = /** @type {(inputs: Directory_Detail_More_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多可探索工具`)
};

/**
* | output |
* | --- |
* | "More tools to explore" |
*
* @param {Directory_Detail_More_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_more_tools = /** @type {((inputs?: Directory_Detail_More_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_More_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_more_tools(inputs)
	return zh_directory_detail_more_tools(inputs)
});
export { directory_detail_more_tools as "directory.detail.more_tools" }